import { gql } from '@apollo/client'

export const GET_VIDEO_FRAMES = gql`
    query GetVideoFrames($assetId: ID!) {
        AdAsset {
            videoFrames(assetId: $assetId) {
                id
                url
                timestamp
                formattedTime
                thumbnail
            }
        }
    }
`
